// Admin panel sections and who may open them. "team" is super-admin only;
// every other section is delegated per manager (userData.adminPermissions).
export const ADMIN_NAV = [
  { id: "metrics", path: "/admin/metrics", label: "Metrics", icon: "analytics" },
  { id: "jobs", path: "/admin/jobs", label: "Jobs", icon: "briefcase" },
  { id: "users", path: "/admin/users", label: "Users", icon: "people" },
  { id: "marketplace", path: "/admin/marketplace", label: "Marketplace", icon: "marketplace" },
  { id: "subscriptions", path: "/admin/subscriptions", label: "Subscriptions", icon: "payment" },
  { id: "locations", path: "/admin/locations", label: "Countries & locations", icon: "location" },
  { id: "audit", path: "/admin/audit", label: "Activity log", icon: "history" },
  { id: "team", path: "/admin/team", label: "Admin team", icon: "admin" },
];

export const canOpenSection = (userData, id) => {
  if (!userData?.isAdmin) return false;
  if (userData.isSuperAdmin) return true;
  if (id === "team") return false;
  return (userData.adminPermissions || []).includes(id);
};

export const allowedAdminNav = (userData) => ADMIN_NAV.filter((n) => canOpenSection(userData, n.id));

export const firstAdminPath = (userData) => allowedAdminNav(userData)[0]?.path || null;
